import { useLocation, useNavigate } from 'react-router-dom';

const TABS: { path: string; label: string }[] = [
    { path: '/plugins/shopify', label: 'Connexion' },
    { path: '/shopify/products', label: 'Produits' },
    { path: '/shopify/orders', label: 'Commandes' },
];

/** Shared sub-navigation across the three Shopify screens, so switching between them doesn't require going back to Extensions each time. */
const ShopifyMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="mb-5 flex flex-wrap gap-2">
            {TABS.map((tab) => {
                const active = location.pathname === tab.path;
                return (
                    <button
                        key={tab.path}
                        onClick={() => navigate(tab.path)}
                        className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${
                            active
                                ? 'bg-navy-700 text-white dark:bg-white dark:text-navy-700'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-navy-700 dark:text-gray-300 dark:hover:bg-navy-600'
                        }`}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default ShopifyMenu;
